export default __webpack_public_path__ + "static/media/filter.59282989.svg";